import { Controller } from "@hotwired/stimulus"

/**
 * ET Probe Row Controller
 * Handles auto-population of probe serial number when a probe is selected
 * in the ET Probe Configuration table rows.
 *
 * Used with Cocoon gem for dynamically added/removed probe configuration rows.
 *
 * Targets:
 *   - probeSelect: The probe dropdown selector
 *   - serialNo: The serial number text field (readonly, auto-populated)
 *
 * Actions:
 *   - onProbeChange: Triggered when probe selection changes
 */
export default class extends Controller {
  static targets = ["probeSelect", "serialNo"]

  connect() {
    console.log("[et-probe-row] Controller connected")
  }

  /**
   * Handle probe selection change
   * Fetches the equipment data and populates the serial number field
   */
  async onProbeChange(event) {
    const equipmentId = event.target.value

    if (!equipmentId) {
      // Clear serial number if no probe selected
      if (this.hasSerialNoTarget) {
        this.serialNoTarget.value = ''
      }
      console.log("[et-probe-row] No probe selected, cleared serial number")
      return
    }

    console.log("[et-probe-row] Probe selected:", equipmentId)

    try {
      const response = await fetch(`/equipment/${equipmentId}.json`)

      if (!response.ok) {
        throw new Error(`Failed to fetch equipment data: ${response.status}`)
      }

      const equipmentData = await response.json()
      console.log("[et-probe-row] Equipment data received:", equipmentData)

      // Populate serial number (or show "Missing serial number" if empty)
      if (this.hasSerialNoTarget) {
        if (equipmentData.serial_no && String(equipmentData.serial_no).trim() !== '') {
          this.serialNoTarget.value = String(equipmentData.serial_no)
          console.log("[et-probe-row] Set Serial No:", equipmentData.serial_no)
        } else {
          this.serialNoTarget.value = 'Missing serial number'
          console.log("[et-probe-row] Probe has no serial number")
        }

        // Trigger change event for autosave compatibility
        this.serialNoTarget.dispatchEvent(new Event('change', { bubbles: true }))
      }
    } catch (error) {
      console.error("[et-probe-row] Failed to fetch equipment data:", error)
    }
  }
}
